module.exports = __webpack_public_path__ + "static/media/vem-ser.c775b267.svg";